function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 .882L15.809 14.5H2.191L9 .882zm0 2.236L3.809 13.5h10.382L9 3.118z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 10.25A6.25 6.25 0 1022 16.5a6.257 6.257 0 00-6.25-6.25zm3.163 5.028L16.13 18.99a1.457 1.457 0 01-1.076.583h-.107c-.389 0-.762-.157-1.035-.434l-1.435-1.436a.75.75 0 011.06-1.06l1.234 1.234a.252.252 0 00.2.072.25.25 0 00.182-.1l2.563-3.475a.752.752 0 011.319.136.75.75 0 01-.119.764l-.003.004z"
});

function SvgMdDeltaResolved(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "mdDeltaResolved.94596.svg";
export { SvgMdDeltaResolved as ReactComponent };